import { ObjectExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { CommerceProperty } from '@msdyn365-commerce/retail-proxy';

export const getCommercePropertyByKey = (key: string, properties: CommerceProperty[]): CommerceProperty | undefined => {
    const property = properties?.find(({ Key }) => Key === key);

    return property;
};

export const getCommercePropertyTextValueByKey = (key: string, properties: CommerceProperty[]): string => {
    const property = getCommercePropertyByKey(key, properties);

    const value = property?.Value?.StringValue;

    return value ?? '';
};

export const getCommercePropertyBooleanValueByKey = (key: string, properties: CommerceProperty[]): boolean => {
    const property = getCommercePropertyByKey(key, properties);

    const value = property?.Value?.BooleanValue;

    return ObjectExtensions.isNullOrUndefined(value) ? false : value;
};
